import React, {Component, PropTypes} from "react";
import {Link} from 'react-router/es';
import Select from 'react-select';

import {formatPrice} from './ingredientsSearchHelper';
import TypeItem from "../../records/TypeItem";
import LoadingImg from "../../assets/img/loading_dots.gif";
import {inlineDecimal} from "./validation";

class SelectedItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            qty: '',
            selectedUnitOption: '',
            unitOptions:[]
        };
    }

    componentDidMount() {
        this.fetchUnitTypes('amountUnitTextKey');
    }

    handleIngredientRemove = (removedIngredient) => {
        this.setState({qty:''});
        this.props.onIngredientRemove(removedIngredient);
    };

    handleQtyOnBlur = (e, ingredient) => {
        let inputQty = e.target.value;
        const isQtyValid = inlineDecimal(inputQty, 4);
        inputQty = isQtyValid ? inputQty : '';

        if (!isQtyValid) {
            this.setState({ qty: inputQty });
        }
        this.props.onIngredientQtyUpdate(ingredient, inputQty, isQtyValid);
    };

    handleQtyOnChange = (e) => {
        this.setState({qty:e.target.value});
    };

    handleUnitOnChange = (selectedUnitOption, ingredient) => {
        const { qty } = this.state;
        const { onIngredientUnitUpdate, onIngredientQtyUpdate } = this.props;

        this.setState({ selectedUnitOption:{...selectedUnitOption, label:selectedUnitOption.value} });

        if (isNaN(qty)) {
            onIngredientQtyUpdate(ingredient, '', false);
        } else {
            onIngredientUnitUpdate(ingredient, selectedUnitOption)
        }
    };

    fetchUnitTypes(unitSource) {
        const { ingredient } = this.props;
        const sortedTypes = this.fetchActiveUnitTypes();

        let defaultOption = {};

        const unitOptions = sortedTypes.map((item) => {
            if (item.get('textKey') === ingredient[unitSource]) {
                defaultOption = {value:item.get('textKey'), label:item.get('textKey')}
            }

            return {value:item.get('textKey'), label:`${item.get('typeItemName')}(${item.get('textKey')})`}
        });

        this.setState({unitOptions, selectedUnitOption:defaultOption});
    }

    /**
     * Returns the appropriate units based on several attributes of the ingredient
     */
    fetchActiveUnitTypes() {
        const { ingredient, unitTypes } = this.props;
        let filteredItems;

        if (ingredient.isBatchRecipe || (ingredient.supc && ingredient.amountUnitTextKey === 'ea')){
            filteredItems = TypeItem.getWeightUnitsByTextKey(unitTypes, ingredient.baseUnitTextKey);
        } else {
            filteredItems = TypeItem.getWeightUnitsByTextKey(unitTypes, ingredient.amountUnitTextKey);
        }

        var distinctItems = filteredItems.groupBy(x => x.id).map(x => x.first()).toList();

        // if don't have value noOfEaches, then filter ea unit from list
        if (!ingredient.noOfEaches > 0) {
            if( ingredient.baseUnitTextKey !=='ea' ) {
                distinctItems = TypeItem.filterOutOneType(distinctItems, 'ea');
            }
        }

        return TypeItem.sortTypeItemsByName(distinctItems);
    }

    renderIngredientCost() {
        const { ingredient } = this.props;

        if (ingredient.isCostPerServingLoading) {
            return (
                <td className={'text-to-right'}>
                    <div style={{width: 60}}>
                        <img src={LoadingImg} alt='...'/>
                    </div>
                </td>
            );
        }

        return (
            <td className={'text-to-right'}>
                <div style={{width: 60}}>
                    {formatPrice(ingredient.costPerServing)}
                </div>
            </td>
        )
    }

    render() {
        const { ingredient } = this.props;
        const { unitOptions, selectedUnitOption } = this.state;

        return (
            <tr>
                <td>{ingredient.note || ingredient.ingredientName}</td>
                <td>
                    <div className='ing-custom-input-wrapper'>
                        <input type={ 'text' }
                                className={ !ingredient.isQtyValid ? 'error-warning' : null }
                                value={ this.state.qty }
                                onBlur={ (e) => this.handleQtyOnBlur(e, ingredient) }
                                onChange={ this.handleQtyOnChange }
                        />
                    </div>
                </td>
                <td>
                    <Select classNamePrefix={ 'opt-right ss-dropdown' }
                            selectedIndex={1}
                            options={ unitOptions }
                            onChange={ value => this.handleUnitOnChange(value, ingredient) }
                            value={ selectedUnitOption }
                    />
                </td>
                { this.renderIngredientCost() }
                <td>
                    <Link onClick={ () => this.handleIngredientRemove(ingredient) } className='mui--pull-right remove-selected-ingredient'>
                        <i className='material-icons'>close</i>
                    </Link>
                </td>
            </tr>
        );
    }
}

SelectedItem.propTypes = {
    ingredient: PropTypes.object,
    onIngredientRemove: PropTypes.func,
    onIngredientQtyUpdate: PropTypes.func,
    onIngredientUnitUpdate: PropTypes.func,
    unitTypes: PropTypes.object,
};

export default SelectedItem;